export const FILTER_ACCOUNT = "9015";
export const FILTER_ACCESS_GROUP = "9012";
export const FILTER_ACCESS_TIME_PATTERN = "9017";
export const FILTER_AREA = "9019";
export const FILTER_BUILDINGS = "9006";
export const FILTER_COMPANIES = "9009";
export const FILTER_CONTROLLER = "9010";
export const FILTER_DAYS = "9024"; // E.g. Days of week. Mon-Sun.
export const FILTER_DEPARTMENTS = "9008";
export const FILTER_DEVICE_TIME_PATTERN = "9018";
export const FILTER_DEVICE_TYPE = "9021";
export const FILTER_DOORS = "9002";
export const FILTER_EVENTS = "9005";
export const FILTER_FLOORS = "9007";
export const FILTER_INPUT_NAME = "9013";
export const FILTER_PROFILE = "9022";
export const FILTER_READERS = "9003";
export const FILTER_REPORT_TYPE = "9016";
export const FILTER_SITES = "9014";
export const FILTER_TAGHOLDERS = "9001";
export const FILTER_TAGHOLDER_TYPE = "9011";
export const FILTER_TAG_TYPE = "9020";
export const FILTER_TIME_ZONE = "9023";
export const FILTER_ZONES = "9004";
export const FILTER_DATE = "9025";
export const FILTER_TRANSACTION_TYPE = "9026";
export const FILTER_TIME = "9027";
export const FILTER_USER_TYPE = "9028";
export const FILTER_OSS_DEVICE = "9029";
export const FILTER_TYPE = "9030";
export const FILTER_SUB_TYPE = "9031";
export const FILTER_ACTION_TYPE = "9032";
export const FILTER_CURRENT = "15021";
export const FILTER_OPERATOR = "9033";
export const FILTER_INACTIVE_FOR = "9034";
export const FILTER_EXPIRY_REASONS = "9035";
export const FILTER_STATUS = "9036";
export const FILTER_ENTRY_TERMINAL = "9037";
export const FILTER_PASS_TERMINAL = "9038";
export const FILTER_FAIL_TERMINAL = "9039";
export const FILTER_RESULT = "9040";
export const FILTER_TIMEOUT_MINUTES = "9041";